// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202605250233/js/" + chunkId + "." + {"44":"ec56c3fd","225":"eb4497b0","481":"b442e32c","486":"a811badc","770":"36bbcb99"}[chunkId] + ".0.7903344616043099.chunk.js";
};